module.exports = __webpack_public_path__ + "img/6fa219f7ff3c8e05423c72d9f28438a1.fc47d51b.png";